import { Stack } from "@mui/material";
import { NO_TRANSLATE_CLASS, Text } from "@flat-ui";
import { BaseProjectProps } from "@custom-types/project-types";
import { useDateTime } from "@hooks/use-date-time";
import { useTranslate } from "@faro-lotv/foreign-observers";

/**
 * Tooltip content showing created, modified, and last captured dates for a project.
 * Shows absolute dates for clarity when used as a hover tooltip.
 * Used across project cards for both desktop and mobile views.
 */
export function ProjectDateTooltip({ project }: BaseProjectProps): JSX.Element {
  const { formatDate } = useDateTime();
  const translate = useTranslate();

  const dateInfo = [
    { label: "Created", value: formatDate(project.createdAt) },
    { label: "Last Updated", value: formatDate(project.modifiedAt) },
    {
      label: "Last Captured",
      value: project.lastCapturedAt
        ? formatDate(project.lastCapturedAt)
        : translate("Never"),
    },
  ];

  return (
    <Stack spacing={0.5}>
      {dateInfo.map(({ label, value }) => (
        <Text key={label} variant="bodyS" color="primary">
         {label}
          <span className={NO_TRANSLATE_CLASS}>: {value}</span>
        </Text>
      ))}
    </Stack>
  );
}
